import { defineComponent as _defineComponent } from 'vue'
import {
  computed, PropType, ref, watch
} from 'vue';
import BCXAbsoluteTransition from '@/components/molecules/BCXAbsoluteTransition.vue';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import BCXDatePickerMonth from '@/components/molecules/forms/datepicker/BCXDatePickerMonth.vue';
import BCXDatePickerNavigation from '@/components/molecules/forms/datepicker/BCXDatePickerNavigation.vue';
import { useVModel } from '@vueuse/core';
import BCXDatePickerYear from '@/components/molecules/forms/datepicker/BCXDatePickerYear.vue';
import BCXDatePickerYears from '@/components/molecules/forms/datepicker/BCXDatePickerYears.vue';
import { LONG_MONTHS } from '@/models/DateTime';
import useI18n from '@/mixins/useI18n';
import { BcxDatePickerTimeLevel } from '@/models/BcxDatePicker';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXDatePicker',
  props: {
  value: {
    type: [String, Date] as PropType<string | Date>,
    default: null
  },
  earliest: {
    type: [String, Date],
    default: null
  },
  latest: {
    type: [String, Date],
    default: null
  }
},
  emits: ['update:value', 'select-timelevel'],
  setup(__props, { emit }) {

const props = __props;





const { locale } = useI18n();

const value = useVModel(props);

const { getFormattedDate } = useFormattedDateTime();

const triggerTransitionCounter = ref(0);
const isSlidingLeft = ref(false);

const timeLevel = ref<BcxDatePickerTimeLevel>(BcxDatePickerTimeLevel.MONTH);

const initialDate = computed(() => new Date(props.value));

const currentDate = ref(new Date(props.value));
const earliestDate = ref(new Date(props.earliest ?? new Date(1970, 0, 1)));
const latestDate = ref(new Date(props.latest ?? new Date(2050, 11, 31)));
const earliestYear = computed(() => earliestDate.value.getFullYear());
const latestYear = computed(() => latestDate.value.getFullYear());

const clampedDate = (date: Date) => {
  if (date < earliestDate.value) {
    date = earliestDate.value;
  } else if (date > latestDate.value) {
    date = latestDate.value;
  }
  return date;
};

watch(value, (value) => {
  if (!value) {
    value = new Date();
  }
  currentDate.value = clampedDate(new Date(value));
}, { immediate: true });

const currentYear = computed(() => currentDate.value.getFullYear());
const currentMonthIndex = computed(() => currentDate.value.getMonth());
const currentDay = computed(() => currentDate.value.getDate());

const incTime = (amount: number) => {
  let nextDate: Date;
  switch (timeLevel.value) {
    case BcxDatePickerTimeLevel.MONTH:
      nextDate = new Date(currentYear.value, currentMonthIndex.value + amount, currentDay.value);
      break;
    case BcxDatePickerTimeLevel.YEAR:
      nextDate = new Date(currentYear.value + amount, currentMonthIndex.value, currentDay.value);
      break;
  }

  // if (nextDate >= earliestDate.value && nextDate <= latestDate.value) {
  currentDate.value = nextDate;
  triggerTransitionCounter.value++;
  isSlidingLeft.value = amount > 0;
  // } else {
  //   currentDate.value = clampedDate(nextDate);
  //   console.log('Out of bounds!');
  // }
};

const onPrev = () => {
  incTime(-1);
};

const onNext = () => {
  incTime(1);
};

const onAdvanceTimeLevel = () => {
  timeLevel.value++;
  if (timeLevel.value > BcxDatePickerTimeLevel.YEARS) { timeLevel.value = BcxDatePickerTimeLevel.MONTH; }
};

const navigationLabel = computed(() => {
  switch (timeLevel.value) {
    case BcxDatePickerTimeLevel.MONTH: return `${LONG_MONTHS[locale.value][currentMonthIndex.value]} ${currentYear.value}`;
    case BcxDatePickerTimeLevel.YEAR: return `${currentYear.value}`;
  }
  return '';
});

const onSelectDate = (date: Date) => {
  if (typeof props.value === 'string') {
    value.value = clampedDate(date).toISOString().slice(0, 10);
  } else {
    value.value = clampedDate(date);
  }
  emit('select-timelevel', timeLevel.value);
  timeLevel.value = BcxDatePickerTimeLevel.MONTH;
};

const onSelectToday = () => {
  currentDate.value = clampedDate(new Date());
  value.value = currentDate.value;
};


return { __sfc: true,props, emit, locale, value, getFormattedDate, triggerTransitionCounter, isSlidingLeft, timeLevel, initialDate, currentDate, earliestDate, latestDate, earliestYear, latestYear, clampedDate, currentYear, currentMonthIndex, currentDay, incTime, onPrev, onNext, onAdvanceTimeLevel, navigationLabel, onSelectDate, onSelectToday, BCXAbsoluteTransition, BCXDatePickerMonth, BCXDatePickerNavigation, BCXDatePickerYear, BCXDatePickerYears, BcxDatePickerTimeLevel }
}

})